import * as React from 'react';

import { translate } from '~l10n/client';
import { WorkspaceRole } from 'clients/app/src/api/workspaces/getWorkspaceMembers';

import { CopyableInputControl } from '~shared/components/CopyableInputControl';
import { Spinner } from '~shared/components/Spinner';

import { useInviteCode } from './hooks';

interface InvitesDialogSectionControlProps {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
}

export function InvitesDialogSectionControlCode({
  workspaceId,
  workspaceRole,
}: InvitesDialogSectionControlProps) {
  const inviteCode = useInviteCode({ workspaceId, workspaceRole });

  if (!inviteCode.data) {
    return <Spinner />;
  }

  return (
    <CopyableInputControl
      textInputClass="font-600"
      label={translate('Invite Code')}
      value={inviteCode.data.code}
    />
  );
}
